/**
 * 📧 Modal para solicitar email personal cuando detecta @temp
 */

import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Typography,
  Alert,
  Box
} from '@mui/material';
import { Warning as WarningIcon } from '@mui/icons-material';
import axios from 'axios';
import { API_BASE_URL } from '../config';

const ModalEmailPersonal = ({ open, onClose, usuario }) => {
  const [emailPersonal, setEmailPersonal] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const validarEmail = (email) => {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(email);
  };

  const handleGuardar = async () => {
    setError('');

    // Validaciones
    if (!emailPersonal) {
      setError('El email es requerido');
      return;
    }

    if (!validarEmail(emailPersonal)) {
      setError('El formato del email no es válido');
      return;
    }

    if (emailPersonal.includes('@temp')) {
      setError('No puedes usar un email temporal (@temp)');
      return;
    }

    setLoading(true);

    try {
      // Actualizar email personal del usuario
      await axios.put(
        `${API_BASE_URL}/api/usuarios/${usuario.id}/email-personal`,
        { email_personal: emailPersonal },
        { withCredentials: true }
      );

      alert('✅ Email actualizado correctamente');
      onClose();
    } catch (err) {
      setError(err.response?.data?.error || 'Error al actualizar el email');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} maxWidth="sm" fullWidth disableEscapeKeyDown>
      <DialogTitle>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <WarningIcon color="warning" />
          <Typography variant="h6">Registrá un Email de Contacto</Typography>
        </Box>
      </DialogTitle>

      <DialogContent>
        <Alert severity="info" sx={{ mb: 2 }}>
          <Typography variant="body2">
            Para continuar, registrá un email de contacto (puede ser tu email
            laboral o uno personal, el que uses habitualmente).
          </Typography>
          <Typography variant="body2" sx={{ mt: 1 }}>
            Lo usamos para poder recuperar tu contraseña y para enviarte
            notificaciones importantes (por ejemplo, cuando se aprueben o
            rechacen tus vacaciones).
          </Typography>
        </Alert>

        <TextField
          fullWidth
          label="Email de Contacto"
          type="email"
          value={emailPersonal}
          onChange={(e) => setEmailPersonal(e.target.value)}
          placeholder="ejemplo@gmail.com"
          margin="normal"
          error={!!error}
          helperText={error}
          autoFocus
        />
      </DialogContent>

      <DialogActions>
        <Button
          onClick={handleGuardar}
          variant="contained"
          disabled={loading || !emailPersonal}
        >
          {loading ? 'Guardando...' : 'Guardar Email'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ModalEmailPersonal;
